import React from 'react';

/**
 * CardSelect — radio group rendered as selectable cards (05 §2.4 card-select).
 * Each card shows a title, a short description and an optional check indicator.
 */
const CardSelect = ({ name, options, value, onChange, columns = 2, disabled }) => (
  <div className={`cy-grid cy-grid--${columns}`} role="radiogroup">
    {options.map((opt) => {
      const checked = value === opt.value;
      return (
        <label
          key={opt.value}
          className={`cy-card cy-card--select${checked ? ' is-checked' : ''}`}
        >
          <input
            type="radio"
            name={name}
            value={opt.value}
            checked={checked}
            disabled={disabled || opt.disabled}
            onChange={() => onChange(opt.value)}
          />
          <div className="cy-card--select-body">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
              <h3 className="cy-card-title" style={{ margin: 0 }}>{opt.title}</h3>
              <span className="cy-card--select-check" aria-hidden="true">{checked ? '\u2713' : ''}</span>
            </div>
            {opt.desc || opt.example ? (
              <p className="cy-card-text" style={{ marginTop: 12 }}>{opt.desc || opt.example}</p>
            ) : null}
            {opt.summary ? (
              <p className="cy-card-text" style={{ marginTop: 8, color: 'var(--cy-color-accent)' }}>{opt.summary}</p>
            ) : null}
          </div>
        </label>
      );
    })}
  </div>
);

export default CardSelect;
